// extracted by mini-css-extract-plugin
export default {"border":"styles_border__7NJGF","placeholder":"styles_placeholder__xYngI"};